import { styled } from "@mui/material/styles";

export const Main = styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, width }: { theme: any; open: boolean; width: string }) => ({
  flexGrow: 1,
  padding: 0,
  marginTop: "calc(57px + env(safe-area-inset-top, 0px))",
  display: "flex",
  position: "relative",
  overflowY: "hidden",
  overflowX: "hidden",
  height: `calc(100vh - 57px - env(safe-area-inset-top, 0px))`,
  minHeight: `calc(100vh - 57px - env(safe-area-inset-top, 0px))`,
  maxHeight: `calc(100vh - 57px - env(safe-area-inset-top, 0px))`,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: "0px",
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));
